import { type WithTextSubSelector } from "@client/content/types";
import TextStyle, { type TextStyleProps } from "@client/controls/Style/Text";
import { getEntitySelector } from "@client/lib/layout";
import { connectCustom, joinDefined } from "@client/lib/misc";
import { TargetSelector, type WithPrefix, getCompositeSettingSelector } from "@client/selectors";
import { type AppState, type EntityRef, HeadingLevel } from "@client/types";

export type ContentTextStyleProps = EntityRef &
  Partial<WithTextSubSelector> &
  Partial<WithPrefix> & {
    selector?: string;
  };
const makeHeadingStyle = (level: HeadingLevel) => {
  const makeMapStateToProps = () => {
    const settingSelector = getCompositeSettingSelector(TargetSelector.Entity, level);

    return (state: AppState, props: ContentTextStyleProps): TextStyleProps => ({
      ...props,
      selector: joinDefined(" ", props.selector ?? getEntitySelector(props.id), props.textSubSelector),
      value: settingSelector(state, props)
    });
  };

  return connectCustom(makeMapStateToProps)(TextStyle);
};
export const ContentH1HeadingStyle = makeHeadingStyle(HeadingLevel.H1);
export const ContentH2HeadingStyle = makeHeadingStyle(HeadingLevel.H2);
export const ContentH3HeadingStyle = makeHeadingStyle(HeadingLevel.H3);
export const ContentH4HeadingStyle = makeHeadingStyle(HeadingLevel.H4);
export const ContentH5HeadingStyle = makeHeadingStyle(HeadingLevel.H5);
export const ContentH6HeadingStyle = makeHeadingStyle(HeadingLevel.H6);
